var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-base',{style:(`--vh: ${_vm.W.h/100}px`),attrs:{"id":"app"}})
}
var staticRenderFns = []

export { render, staticRenderFns }